<div class="spotlight primary-color-text-hover" *ngIf="canDisplay">
  <div class="image" *ngIf="playingVideo; else imageThumb">
    <flo-image-overlay
      *ngIf="imageUrl"
      [imgSrc]="imageUrl | floImage: 330 : 330 | async"
      gradient="full"
      contentPosition="center"
    >
      <h3 class="now-playing">Now Playing</h3>
    </flo-image-overlay>
  </div>
  <ng-template #imageThumb>
    <div class="image" data-test="spotlight-thumbnail">
      <flo-image-thumbnail
        [imageUrl]="imageUrl"
        [imageSize]="400"
        [altText]="title"
        [duration]="duration"
      ></flo-image-thumbnail>
    </div>
  </ng-template>
  <div
    class="title"
    [class.subheader]="smallThumbnail"
    data-test="spotlight-title"
  >
    <ng-container *ngIf="premium">
      <span
        *ngIf="lightProBadge; else darkBadge"
        floSvg="badge_pro_light"
        class="me-1 align-text-top"
      ></span>
      <ng-template #darkBadge>
        <span
          floSvg="badge_pro_dark"
          data-test="pro"
          class="me-1 align-text-top"
        ></span>
      </ng-template>
    </ng-container>
    <span class="apply-text-hover">{{ title }}</span>
  </div>

  <div class="date-footnote mt-2"
       data-test="spotlight-footnote"
       *ngIf="publishDateValid"
  >
    <p data-test="spotlight-date"
       class="subhead m-0"
    >
      {{ publishDate | date }}
    </p>
  </div>
</div>
